import type { TranslationCatalog } from "../TranslationManager";

export const hi: TranslationCatalog = {
  "labels.cardNumber": "कार्ड नंबर",
  "labels.expirationDate": "समाप्ति तिथि",
  "labels.cvc": "सुरक्षा कोड",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "आपका कार्ड नंबर अमान्य है।",
  "errors.invalidExpiryDate": "आपके कार्ड की समाप्ति तिथि अमान्य है।",
  "errors.invalidCvc": "आपके कार्ड का सुरक्षा कोड अमान्य है।",
  "errors.incompleteCardNumber": "आपका कार्ड नंबर अपूर्ण है।",
  "errors.incompleteExpiryDate": "आपके कार्ड की समाप्ति तिथि अपूर्ण है।",
  "errors.incompleteCvc": "आपके कार्ड का सुरक्षा कोड अपूर्ण है।",
  "errors.expiredCard": "आपका कार्ड समाप्त हो चुका है।",
  "aria.cardNumber": "कार्ड नंबर",
  "aria.expirationDate": "समाप्ति तिथि",
  "aria.cvc": "सुरक्षा कोड",
  "aria.cardInput": "कार्ड जानकारी",
};
